export default {
  /**
   * Body has some default margins that conflict with
   * many of our main containers such as Masthead and
   * Footer.
   */
  body: {
    margin: "unset"
  },

  /**
   * Reset default margin and padding for all headings and
   * paragraph, to be consistent with WFRIA v3.
   */
  "h1, h2, h3, h4, h5, h6, p": {
    margin: 0,
    padding: 0
  },

  /**
   * 1. Correct the inheritance and scaling of font size.
   * 2. Correct the odd `em` font sizing.
   */
  "pre, code, kbd, samp": {
    fontFamily: "monospace"
    /* 1 */
    ,
    fontSize: "1em"
    /* 2 */

  },

  /**
   * For images to not be able to exceed their container
   */
  img: {
    maxWidth: "100%"
  },

  /**
   * Removes spacing between cells in tables.
   */
  table: {
    borderCollapse: "collapse"
  },

  /**
   * Revert the 'white-space' property for textarea elements on Safari
   */
  textarea: {
    whiteSpace: "revert"
  },

  /**
   * Remove default ugly fieldset styles.
   */
  fieldset: {
    border: "none",
    padding: 0,
    margin: 0
  }
};